export enum ProductCategory {
    ConnectionService = 'Connection Service',
    ServiceActivation = 'Service Activation',
    AdditionalAndOptionalServices = 'Additional and Optional Services',
    Options = 'Options',
    InstallationServices = 'Installation Services'
  }